export default __webpack_public_path__ + "static/media/clicked-disabled.731465ef.svg";